import deepMapKeys from 'deep-map-keys'
import { snakeCase } from 'lodash'
import type { DiscountCoupon } from '@mc/api'
import { track, EventTypes } from '@mc/track-event'
import { getAccountId } from '@mc/user-info'

export const trackPromoModalViewed = ({
  discount: { slug, promoStatus, ...discountData },
}: Record<string, DiscountCoupon>) =>
  track(EventTypes.PROMO_MODAL_VIEWED, {
    user_id: getAccountId(),
    ...deepMapKeys(discountData, snakeCase),
    coupon_code: slug,
    status: promoStatus,
  })

export const trackPromoModalCta = (
  action: string,
  discountData: DiscountCoupon,
) =>
  track(EventTypes.PROMO_MODAL_CTA_CLICKED, {
    user_id: getAccountId(),
    ...deepMapKeys(discountData, snakeCase),
    action,
  })

export const trackOfferTermsClick = (discountData: DiscountCoupon) =>
  track(EventTypes.PROMO_MODAL_TERMS_CLICKED, {
    user_id: getAccountId(),
    ...deepMapKeys(discountData, snakeCase),
  })
